import merge from 'lodash/merge';
import themeMapper from '@gravity/theme-mapper';

//
function theme(style) {
  // get the theme from the equilibrium properties
  const defaultTheme = themeMapper(style);
  // get the theme for the current widget , values specific to the widget
  const widgetTheme = {};
  // Merge the basic style to be backward compatible, but it should disappear later
  return merge(defaultTheme, widgetTheme, style);
}

export default theme;
